import React from 'react';
import { Callout, Paragraph } from '@piggybank/core';
import { Translation } from 'srcAlias/client/locale';
export const CalloutMobilex = () => {
  return (
    <Callout type="information">
      <Paragraph>
        <Translation path={'utMobilexText'} />
      </Paragraph>
    </Callout>
  );
};
